import { render, staticRenderFns } from "./CategoryTableRestrictionsSettings.vue?vue&type=template&id=6c28142b&scoped=true"
import script from "./CategoryTableRestrictionsSettings.vue?vue&type=script&lang=js"
export * from "./CategoryTableRestrictionsSettings.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CategoryTableRestrictionsSettings.vue?vue&type=style&index=1&id=6c28142b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28142b",
  null
  
)

export default component.exports